<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <form>
        <div class="row1">
          <div class="col1">
            <Select
              v-model="etage"
              description="Etage"
              :options="Etage"
              label="nom"
              placeholder=""
            />
            <Select
              v-model="date"
              description="Date de livraison"
              :options="DateLivraison"
              label="nom"
              placeholder=""
            />
            <Select
              v-model="zoneFiscale"
              description="Zone fiscale"
              :options="ZoneFiscale"
              label="nom"
              placeholder=""
            />
             <div class="col2" style="display:inline-block;">
            <p class="select_title">Promoteur</p>
            <multiselect
              v-model="promoteur"
              label="text"
              track-by="value"
              placeholder="Recherche promoteur"
              select-label="✔"
              deselect-label="✘"
              :multiple="true"
              :options="listePromoteurs"
              open-direction="bottom"
              :internal-search="false"
              :searchable="true"
              :show-no-results="false"
              :hide-selected="false"
              :close-on-select="true"
              @search-change="searchPromoteurs"
              @remove="change2">
          </multiselect>
          </div>
          </div>
          <div class="col1">
            <p class="select_title">Exposition</p>
            <multiselect
              v-model="exposition"
              label="text"
              track-by="value"
              placeholder="select exposition"
              select-label="✔"
              deselect-label="✘"
              :multiple="true"
              :options="Exposition"
              open-direction="bottom"
              :internal-search="false"
              :searchable="true"
              :show-no-results="false"
              :hide-selected="false"
              :close-on-select="true"
              :clear-on-select="true"
              @remove="change2"
              style="margin: 8px;width: 94%;">    
          </multiselect>
           
            <Input
              v-model="commission"
              description="Commission supérieur ou égale à"
              datatype="number"
              placeholder="Ex:5"
            />
            <Select
              v-model="disponibiliteLot"
              description="Disponibilité des lots"
              :options="DisponibiliteLot"
              label="nom"
              placeholder=""
            />
             <div class="col2" style="display:inline-block;">
            <p class="select_title">Programme</p>
            <multiselect
                v-model="programmes"
                label="text"
                track-by="value"
                placeholder="Recherche programme"
                select-label="✔"
                deselect-label="✘"
                :multiple="true"
                :options="listeProgrammes"
                open-direction="bottom"
                :internal-search="false"
                :searchable="true"
                :show-no-results="false"
                :hide-selected="false"
                :close-on-select="true"
                @search-change="searchProgrammes"
                @remove="change2">
            </multiselect>
          </div>
          </div>
          <div class="col1" style="display: flex;flex-direction: column;">
            <h5 class="description">Type</h5>
            <div class="content" style="flex:1">
              <div class="RadioG">
                <label
                  class="btn"
                  :class="{ active: Type == types[0].value }"
                  for="0"
                  >{{ types[0].text }}
                  <input
                    class="radio"
                    id="0"
                    type="radio"
                    :value="types[0].value"
                    v-model="Type"
                  />
                </label>
                <label class="btn"   :class="{ active: Type == types[1].value }" for="1" 
                  >{{ types[1].text }}
                  <input
                    class="radio"
                    id="1"
                    type="radio"
                    :value="types[1].value"
                    v-model="Type"
                  />
                </label>
              </div>
              <div class="RadioG">
                <label class="btn"  :class="{ active: Type == types[2].value }" for="2"
                  >{{ types[2].text }}
                  <input
                    class="radio"
                    id="2"
                    type="radio"
                    :value="types[2].value"
                    v-model="Type"
                  />
                </label>
                <label class="btn"  :class="{ active: Type == types[3].value }" for="3"
                  >{{ types[3].text }}
                  <input
                    class="radio"
                    id="3"
                    type="radio"
                    :value="types[3].value"
                    v-model="Type"
                  />
                </label>
              </div>
            </div>
            <div class="content" style="flex:0.2">
              <div class="col1">
                <Check v-model="check1" description="Nouveaus lots uniquement" />
              </div>
              <div class="col1">
                <Check v-model="check2" description="Retours de lots uniquement" />
              </div>
             
            </div>
          </div>
        </div>
        <div class="row1">
         
         
        </div>
         <div class="col1">
          <button type="button" class="btn" @click="change">Valider</button>
        </div>
       
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Multiselect from 'vue-multiselect'
import Select from "./Select";
import Input from "./Input";
import Check from "./Check";
export default {
  mounted(){
  
  },
  data() {
    return {
      selected: null,
      check1: null,
      check2: null,
      Type: null,
      etage: 0,
      date: 0,
      zoneFiscale: 0,
      exposition: null,
      commission: null,
      disponibiliteLot: 0,
      promoteur: null,
      programmes: null,
      types: [
        { value: 0, text: "Terrasse & Balcon" },
        { value: 1, text: "Parking" },
        { value: 2, text: "Loggia" },
        { value: 3, text: "Jardin" }
      ],
      Etage: [
        { value: 0, nom: "Indifférent", selected: 0},
        { value: 1, nom: "Pas de RDC" },
        { value: 2, nom: "2ème étage et plus" }
      ],
      Exposition: [
        { value: 0, text: "Indifférent" },
        { value: 1, text: "Pas d'exposition nord" },
        { value: 2, text: "Ouest" },
        { value: 3, text: "Sud" },
        { value: 4, text: "Est" },
        { value: 5, text: "Nord" }
      ],
      DateLivraison: [
        { value: 0, nom: "Indifférent(e)" },
        { value: 1, nom: "Déjà livré" },
        { value: 2, nom: "Cette Année" },
        { value: 3, nom: "D'ici fin "+parseInt(new Date().getFullYear()+1)},
        { value: 4, nom: "D'ici fin "+parseInt(new Date().getFullYear()+2)}
      ],
      ZoneFiscale: [
        { value: 0, nom: "Indifférent" },
        { value: 1, nom: "A" },
        { value: 2, nom: "Abis" },
        { value: 3, nom: "B1" },
        { value: 4, nom: "B1 Outre-Mer (DOM)" },
        { value: 5, nom: "B1 Outre-Mer (TOM)" },
        { value: 6, nom: "B2" },
        { value: 7, nom: "C" }
  
      ],
      DisponibiliteLot: [
        { value: 0, nom: "Indifférent(e)" },
        { value: 1, nom: "Disponibles" },
        { value: 2, nom: "Optionnés" }
      ],
      
    };
  },
  props:{
    show: {
      type: Boolean
    },
    Etages: {
      type: Number
    },
    Livraison : {
      type: Number
    },
    Expositions: {
      type: Object
    },
    Commission: {
      type: Number
    },
    zFiscale: {
      type: Number
    },
    valueDisponibiliteLots: {
      type: Number
    },
    Promoteur: {
      type: Object
    },
    programme: {
      type: Object
    }
  },

  computed: {
    ...mapGetters(["listePromoteurs","listeProgrammes"])
  },
  methods: {
    ...mapActions(["getPromoteurs","getProgrammes"]),
    change() {
      let t = this.Type
      let tt=[]    
      switch(t){
        case 0:
          tt.push({ text: "Terrasse & Balcon", value: 0})
          break;
        case 1:
          tt.push({ text: "Parking", value: 1 })
          break;
        case 2:
          tt.push({ text: "Loggia", value: 2 })
          break;
        case 3:
          tt.push({ text: "Jardin", value: 3 })
          break;
        default: 
          tt = []
          break
      }
      if(this.etage >= 0) localStorage.setItem("etage",this.etage);
      if(this.exposition != null) localStorage.setItem("exposition",JSON.stringify(this.exposition));
      if(this.promoteur != null) localStorage.setItem("promoteur",JSON.stringify(this.promoteur)) ;
      if(this.programmes != null) localStorage.setItem("programme",JSON.stringify(this.programmes)) ;

      this.$emit('change', {etage: this.etage, 
                            date: this.date,
                            zoneFiscale: this.zoneFiscale,
                            exposition: this.exposition,
                            commission: this.commission,
                            disponibiliteLot: this.disponibiliteLot,
                            Type: tt,
                            promoteur: this.promoteur,
                            programmes: this.programmes,
                            })

    },
    change2() {
      // this.promoteur = null
      // this.programmes = null
      // this.exposition = null
    },
    searchPromoteurs(query){
      if(query.length >= 2){
        this.getPromoteurs({promoteur: query}).then(res => {
        //  this.
        })
      }
    },
    searchProgrammes(query){
      if(query.length >= 2){
          this.getProgrammes({programme: query}).then(res => {
            //  this.
          })
      }
    },
  },
  components: {
    Select,
    Input,
    Check,
    Multiselect
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    Etages(value) {
      this.etage = value
    },
    Livraison(value) {
      this.date = value
    },
    Expositions(value) {
      this.exposition = value
    },
    Commission(value) {
      this.commission = value
    },
    zFiscale(value) {
      this.zoneFiscale = value
    },
    valueDisponibiliteLots(value) {
      this.disponibiliteLot = value
    },
    Promoteur(value) {
      this.promoteur = value
    },
    programme(value) {
      this.programmes = value
    },
  },
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  right: 10px;
  width: 85%;
  margin-top: 15px;
  .modal {
    width: 92%;
    background-color: #f2fdff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    .row1 {
      display: flex;
      width: 100%;
      .col1 {
        width: 35%;
        display: inline;
        .row {
          p {
            margin-left: 15px !important;
            margin-top: 5px;
            margin-bottom: 20px;
            color: #22ABC5;
            font-size: 15px;
            font-family: Metropolis;
          }
        }
        .select_title{
          margin-left: 10px;
          margin-top: 16px;
          margin-bottom: 10px;
          color: #22ABC5;
          font-size: 15px;
        }
        .description {
          margin-top: 10px;
          margin-bottom: 0px;
          margin-left: 15px;
          color: #22abc5;
          font-weight: normal;
          font-size: 15px;
          font-family: Metropolis;
        }
        .content {
          margin-bottom: 10px;
          height: 30px;
          display: inline;
          .RadioG {
            display: flex;
            padding: 12px;
            .btn {
              margin: 5px;
              padding: 12px;
              border: 1px solid #22abc5;
              border-radius: 5px;
              color: #ffffff;
              background-color: #22abc5;
              text-align: center;
              font-size: 15px;
              font-family: Metropolis;
              &.active {
                border: 1px solid #ff8c00;
                color: #ffffff;
                background: darkorange;
              }
              &:hover {
                cursor: pointer;
              }
              .radio {
                display: none;
              }
            }
          }
        }
      }
      .col2 {
        width: 100%;
        display: flex;
        .select_title{
            margin-left: 10px;
            margin-top: 5px;
            margin-bottom: 10px;
            color: #22ABC5;
            font-size: 15px;
            font-family: Metropolis;
        }
        .multiselect {
          color: #b5bcbd;
          background-color: white;
          padding: 0px;
          width: 94%;
          border-radius: 7px;
          border-color: #8c9a9c;
          margin-top: 0px;
          /* margin-left: 0%; */
          margin: 8px;
          &:focus {
            outline: 0;
          }
          &::placeholder {
            color: #22a1b9;
            font-family: Metropolis;
          }
          .option {
            font-size: 10px;
          }
          .multiselect__tags {
            min-height: 43px;
            display: block;
            border-radius: 5px;
            border: 1px solid #f2fdff;
            background: #fff;
            font-size: 13px;
            padding: 7px;
            font-family: Metropolis;
          }
        }
        
      }
      
    }
    .btn {
      margin-top: 5px;
      width: 100%;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #22abc5;
      padding: 12px;
      outline: 0;
      font-family: Metropolis;
      font-size: 15px;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 768px) {
.modal-backdrop{
   width:250px ;
  position: initial;
  .modal{
    .row1{
      display:inline;
    .col1{
      .description{
        margin-bottom: 0px;
      }
      .content{
        .RadioG{
          display:inline-grid ;
          .btn{
            text-align: center;
            width: 42px;
            height: 35px;
          }
        }
      }
    }
    }
  }
}  
}
@media screen and (max-width: 425px) {
.modal-backdrop{
  width:175px ;
   .modal{
     .row1 {
      display: inline;
  }
   }
  
}
}
</style>
